<script lang="ts">
    import {onMount} from "svelte";
    import HeadingTitleView from "../../component/common/Typography/HeadingTitleView.svelte";
    import {AuthStore} from "../../store/AuthStore";
    import LinkButtonView from "../../component/common/Button/LinkButtonView.svelte";

    $: authStoreUser = AuthStore.user;

    onMount(() => {
    });


</script>

<div class="admin-page standard-page">
    <HeadingTitleView title="管理者メニュー"/>

    <div class="button-list">
        <LinkButtonView url="/#/admin/space_user_access_log" text="スペースのアクセスログの閲覧"/>
        <LinkButtonView url="/#/admin/user_list" text="ユーザーリスト"/>

    </div>

</div>
<style lang="scss">
    .admin-page {
        .button-list {
            display: flex;
            flex-wrap: wrap;
            gap: 32px;
        }
    }
</style>